import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from "@angular/router";

@Component({
  selector: 'app-latest-information',
  templateUrl: './latest-information.component.html',
  styleUrls: ['./latest-information.component.scss']
})
export class LatestInformationComponent implements OnInit {
  @Input() titleHeader;//标题名称
  @Input() hotInfoData;//资讯列表
  @Output() jobSelectId: any = new EventEmitter();
  @Output() companySelectId: any = new EventEmitter();
  constructor(
    private _router: Router
  ) { }

  ngOnInit() {
    this.titleHeader = "最新资讯";
  }
  //资讯详情
  jumpInfoDetail(did: string) {
    this._router.navigate(['/information/job-infor-detail/', did]);

  }
}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/job/latest-information/latest-information.component.ts